import AssetSensorProvider from '@opsbase/lib-asset/AssetSensor/AssetSensorProvider';
import { DataType } from '@opsbase/lib-datatype/DataType';
import doNothing from '@opsbase/lib-general/utils/doNothing';
import i18n from '@opsbase/lib-i18n';
import useAssetUpdate from '@opsbase/react-gql-hooks/asset/useAssetUpdate';
import useOrgIoTSensors from '@opsbase/react-gql-hooks/organisation/useOrgIoTSensors';
import useNewDataActions from '@opsbase/web-ctrl-newdata/useNewDataActions';
import ItemChooser from '@opsbase/web-data-choosers/ItemChooser';
import Pane from '@opsbase/web-layout/Pane';
import Vertical from '@opsbase/web-layout/Vertical';
import Spinner from '@opsbase/web-ui/Spinner';
import React, { useCallback, useMemo } from 'react';
import SensorCharts from './SensorCharts';
export function AssetEditSensorTab(props) {
    const { asset } = props;
    const { loading, data: sensors } = useOrgIoTSensors();
    const updateAsset = useAssetUpdate();
    const { updateItemsForType } = useNewDataActions();
    const selectedSensor = useMemo(() => {
        if (!asset || !sensors)
            return;
        const sensor = asset.sensor ? JSON.parse(asset.sensor) : undefined;
        return !!sensor ? sensors.find(s => s.name === sensor.sensorId) : undefined;
    }, [sensors, asset]);
    const handleChangeSensor = useCallback((newSensors) => {
        var _a;
        let sensor = '';
        if (newSensors === null || newSensors === void 0 ? void 0 : newSensors.length) {
            sensor = JSON.stringify({
                provider: AssetSensorProvider.DISRUPTIVE_TECH,
                sensorId: (_a = newSensors === null || newSensors === void 0 ? void 0 : newSensors[0]) === null || _a === void 0 ? void 0 : _a.name,
            });
        }
        updateAsset({ id: asset.id, patch: { sensor } })
            .then(a => updateItemsForType(DataType.ASSET, [a]))
            .catch(doNothing);
    }, [asset, updateAsset, updateItemsForType]);
    return useMemo(() => (React.createElement(Spinner, { busy: loading }, () => (React.createElement(Vertical, { gutter: true },
        React.createElement(Pane, { padding: true },
            React.createElement(ItemChooser, { label: i18n.t('asset-sensor-help'), items: sensors, value: selectedSensor ? [selectedSensor] : [], onChange: handleChangeSensor })),
        !!selectedSensor && (React.createElement(Pane, { grow: true, padding: true, visible: true },
            React.createElement(SensorCharts, { sensors: [selectedSensor] }))))))), [handleChangeSensor, loading, selectedSensor, sensors]);
}
export default AssetEditSensorTab;
